import {
  buildWarehouseApplicationPayload,
  createBlankWarehouseApplication,
  normalizeWarehouseApplication,
} from "../warehouseApplications/warehouseApplications";
import { getWarehouseApplications } from "../warehouseApplications/warehouseApplicationsService";
import { PageRecord } from "../recordDefinition.types";

// A radio holds numbers, not booleans, so the audit choice is 1 or 0 on the page.
function toPageRecord(application: PageRecord): PageRecord {
  const normalized = normalizeWarehouseApplication(application);

  return {
    ...normalized,
    id: normalized.ApplicationId ?? undefined,
    AuditProfileChanges: normalized.AuditProfileChanges ? 1 : 0,
  };
}

/** Warehouse has no read by id, so the application is found in the full list. */
export async function readWarehouseApplication(id: string) {
  const applications: PageRecord[] = (await getWarehouseApplications()) ?? [];
  const found = applications.find(
    (application) => String(application.ApplicationId) === id
  );

  return found ? toPageRecord(found) : null;
}

export const newWarehouseApplication = toPageRecord(
  createBlankWarehouseApplication()
);

export const toWarehouseApplicationPayload = (record: PageRecord) =>
  buildWarehouseApplicationPayload({
    ...record,
    ClientSecret: record.ClientSecret || "",
  });

const isWholeIdList = (value: string) =>
  value
    .split(",")
    .every((token) => Number.isInteger(Number(token.trim())) && Number(token.trim()) > 0);

export const warehouseApplicationValidators = {
  // Required only when creating, as a stored one is never read back.
  warehouseClientSecret: (value: unknown, record: PageRecord) =>
    !record.id && !value ? "Client Secret is required" : "",
  warehouseMatchKeySet: (value: unknown) => {
    const text = String(value ?? "").trim();
    return text && !isWholeIdList(text)
      ? "Match key set must be a comma-separated list of ids."
      : "";
  },
};
